import { MtTaskParticipant } from "server/models"
import { GET, DELETE, POST } from "client/store/utils"
import { TaskParticipantList } from "./types"


export const LoadAllTaskParticipants = () => (
    GET("/mtTaskParticipant/all")
    .then((rows: MtTaskParticipant[]) => {
        const taskParticipantList: TaskParticipantList = {}
        rows.forEach((row) => {
            const userIds: number[] = taskParticipantList[row.taskId] ? taskParticipantList[row.taskId].slice() : []
            userIds.push(row.userId)
            taskParticipantList[row.taskId] = userIds
        })
        return taskParticipantList
    })
)

export const LoadTaskParticipants = (taskId: number) => (
    GET(`/mtTaskParticipant/taskId/${taskId}`)
    .then((rows: MtTaskParticipant[]) => {
        const userIds: number[] = []
        rows.forEach((row) => {
            userIds.push(row.userId)
        })
        return userIds
    })
)

const createParticipantList = (userIds: readonly number[], taskId: number) => {
    const participants: MtTaskParticipant[] = []
    userIds.forEach((userId) => {
        participants.push({
            taskId,
            userId,
        })
    })
    return participants
}

export const AddTaskParticipants = (userIds: readonly number[], taskId: number) => {
    const newParticipants = createParticipantList(userIds, taskId)
    return POST(
        "/mtTaskParticipant/add",
        JSON.stringify(newParticipants),
    )
}

export const SaveTaskParticipantList = (userIds: readonly number[], taskId: number) => {
    const updatedParticipants = createParticipantList(userIds, taskId)
    return POST(
        "/mtTaskParticipant/save",
        JSON.stringify(updatedParticipants),
    )
}

export const DeleteTaskParticipant = (userId: number, taskId: number) => (
    DELETE(`/mtTaskParticipant/delete/${userId}/${taskId}`)
    .then((removedRows: number) => removedRows)
)
